import { useEffect, useRef } from 'react'

/**
 * Returns the previous value of a variable from the last render.
 * Returns undefined on the first render.
 *
 * @example
 * const [count, setCount] = useState(0)
 * const prevCount = usePrevious(count)
 * // On first render: prevCount === undefined
 * // After setCount(1): prevCount === 0
 * // After setCount(2): prevCount === 1
 */
export function usePrevious<T>(value: T): T | undefined {
	const ref = useRef<T | undefined>(undefined)

	useEffect(() => {
		ref.current = value
	}, [value])

	return ref.current
}
